import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { IoSearchOutline } from "react-icons/io5";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import LeaseApiService from '../../services/apiService';
import WindowedSelect from 'react-windowed-select';
import moment from 'moment/moment';
import { Modal, Button, Form } from "react-bootstrap";
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from "react-spinners";

const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const PaymentManagement = () => {
    const [FilterTab, setFilterTab] = useState(true);
    const [show, setShow] = useState(false);
    const [unitList, setUnitList] = useState([])
    const [proprtyList, setProperty] = useState([]);
    const [accountType, setAccountType] = useState([]);
    const [transList, setTransList] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [apar, setAPAR] = useState([]);
    const [selectedTrans, setSelectedTrans] = useState([]);
    const apiService = new LeaseApiService();
    const [loading, setloader] = useState(false);
    const [periodFrom, setPeriodFrom] = useState("");
    const [periodTo, setPeriodTo] = useState("");
    const [contextMenu, setContextMenu] = useState(null);
    const [selectedOption, setSelectedOption] = useState('Voucher');
    const [isCleared, setIscleared] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const today = new Date();
    const navigate = useNavigate();
    const formattedDate = today.toISOString().split('T')[0]; // DD-MMM-YYYY
    const [formData, setFormData] = useState({
        clearingDate: formattedDate,
        status: "",
        remarks: "",
    });

    useEffect(() => {
        fetchDropdownData();
    }, []);

    useEffect(() => {
        const today = new Date();

        // Clone today's date and subtract one month
        const lastMonth = new Date(today);
        lastMonth.setMonth(today.getMonth() - 1);

        const formattedToday = today.toISOString().split("T")[0];
        const formattedLastMonth = lastMonth.toISOString().split("T")[0];

        setPeriodFrom(formattedLastMonth);
        setPeriodTo(formattedToday);
        setFormData({ ...formData, clearingDate: formattedToday });

        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);

        return () => window.removeEventListener('click', handleClickOutside);
    }, []);

    const [transData, setTransData] = useState({
        accountType: [{ label: 'Select Account Type', value: '' }],
        APAR: [{ label: 'Select AP / AR', value: '' }],
        property: [{ label: 'Select Property', value: '' }],
        tranType: [{ label: 'Select Tran Type', value: '' }],
        uniNo: [{ label: 'Select Unit No', value: '' }],
    });
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'MpSerTranTypes,MpSerAccounttype,MpSerARAP,MpSerPropertyNos');
            const res = await apiService.getApiParamater('PAYMENT_MULTI', `?${params.toString()}`);
            setProperty(res?.data?.dropdowns?.MpSerPropertyNos)
            setAPAR(res?.data?.dropdowns?.MpSerARAP)
            setTransList(res?.data?.dropdowns?.MpSerTranTypes)
            setAccountType(res?.data?.dropdowns?.MpSerAccounttype)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handlePropertyChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append('DropdownFor', 'MpSerUnitNosByPropertyId');
        params.append('CascadValue', selectedOption?.value);
        const res = await apiService.getApiParamater('PAYMENT_CASCAD', `?${params.toString()}`);
        setUnitList(res?.data?.items);
        setTransData({
            ...transData,
            property: selectedOption,
            uniNo: [{ label: '', value: '' }]
        });
    }
    const handleUitNo = (selectedOption) => {
        setTransData({ ...transData, uniNo: selectedOption });
    }
    const handleAccountType = (selectedOption) => {
        setTransData({ ...transData, accountType: selectedOption });
    }
    const handleTransType = (selectedOption) => {
        setTransData({ ...transData, tranType: selectedOption });
    }
    const handleApAr = (selectedOption) => {
        setTransData({ ...transData, APAR: selectedOption });
    }
    const handleTransSearch = async () => {
        const params = new URLSearchParams();
        params.append('Action', 'GetPDCOrChequeManagrpayment');
        params.append('AcCode', transData?.accountType.value || "All");
        params.append('FromDate', moment(periodFrom).format("DD-MMM-YYYY"));
        params.append('ToDate', moment(periodTo).format("DD-MMM-YYYY"));
        params.append('ChkClear', isCleared);
        params.append('TranType', transData?.APAR?.label || "All");
        params.append('PropertyNo', transData?.property?.value || "All");
        params.append('UnitNo', transData?.uniNo?.label || "All");
        params.append('Mode', selectedOption);
        const res = await apiService.getApiParamater('PAYMENT_COMMON', `?${params.toString()}`);
        setDataList(res?.data?.result?.data);
    }
    const handleClearFilters = () => {
        setTransData({
            accountType: [{ label: 'Select Account Type', value: '' }],
            APAR: [{ label: 'Select AP / AR', value: '' }],
            property: [{ label: 'Select Property', value: '' }],
            tranType: [{ label: 'Select Tran Type', value: '' }],
            uniNo: [{ label: 'Select Unit No', value: '' }],
        });
        setSelectedTrans()
        setUnitList([])
        setTransList([])
    }
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handlePeriodFromChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodFrom(formattedDate);
    }
    const handlePeriodToChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodTo(formattedDate);
    }
    const handleRadioChange = (e) => {
        setSelectedOption(e.target.value);
    };
    const handleCleared = () => {
        setIscleared(!isCleared);
    };
    const handleCheckboxChange = (index, checked) => {
        if (checked) {
            // open modal with row data if already present
            const row = dataList[index];
            setFormData({
                clearingDate: formattedDate,
                status: row.Status || "",
                remarks: row.Remarks || "",
            });
            setSelectedIndex(index);
            setShowModal(true);
        } else {
            // clear values when unchecked
            const updated = [...dataList];
            updated[index] = {
                ...updated[index],
                ClearedDate: null,
                Status: "",
                Remarks: "",
                IsChequeCleared: false,
            };
            setDataList(updated);
        }
    };
    const handleUpdate = () => {
        if (selectedIndex === null) return;
        const updated = [...dataList];
        updated[selectedIndex] = {
            ...updated[selectedIndex],
            clearingDate: formData.clearingDate,
            Status: formData.status,
            Remarks: formData.remarks,
            IsChequeCleared: true,
        };
        setDataList(updated);
        setShowModal(false);
        setSelectedIndex(null);
    };
    const handleSave = async () => {
        try {
            setloader(true);
            const currentDatetimeUTC = new Date().toISOString();
            const clearedPayments = dataList.filter(item => item.IsChequeCleared === true);
            if (clearedPayments.length === 0) {
                toast.warning(" At least one cheque must be Selected.");
                setloader(false);
                return;
            }
            if (clearedPayments?.length > 0) {
                const paymentFillGrid = clearedPayments?.map(item => ({
                    postingId: item.PostingId || "",
                    postingDate: item.PostingDate || null,
                    voucherNo: item.VoucherNo || "",
                    voucherType: item.VoucherType || "",
                    chequeNo: item.ChequeNo || "",
                    chequeDate: item.ChequeDate || null,
                    isChequeCleared: item.IsChequeCleared ?? false,
                    status: item.Status || "",
                    curStatus: item.CurStatus || "",
                    remarks: item.Remarks || "",
                    drawnBank: item.DrawnBank || "",
                    clearedDate: item.clearingDate || null,
                    clearedBy: item.ClearedBy || "",
                    orgIsApproved3: item.orgIsApproved3 ?? false,
                    financialYear: item.FinancialYear || "",
                    isUpdated: item.IsUpdated ?? false,
                    transactionMethod: item.TransactionMethod || "",
                    amount: item.Amount ?? 0,
                    isRejected: item.IsRejected ?? false,
                    rejectedReason: item.RejectedReason || "",
                    isDiscount: item.IsDiscount ?? false,
                    tranDate: item.TranDate || currentDatetimeUTC,
                    discountPercent: item.DiscountPercent ?? 0,
                    discountAmount: item.DiscountAmount ?? 0,
                    costCenter1: item.CostCenter1 || "",
                    costCenter2: item.CostCenter2 || "",
                    defaultDate: item.DefaultDate || null,
                    ischecked: item.IsChequeCleared ?? false,
                    modifiedBy: "", // Assuming this comes from elsewhere
                    isCleared: item.IsChequeCleared ?? false // Assuming "isCleared" maps to IsChequeCleared
                }));
                debugger
                const body = {
                    managepaymentMain: {
                        creditNote_PostingDate: currentDatetimeUTC,
                        voucherDate: currentDatetimeUTC,
                        chequeDate: currentDatetimeUTC,
                        paymentFillGrid: paymentFillGrid,
                    },
                };
                const postRes = await apiService.post("POST_PAYMENT", body);
                if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                    setloader(false);
                    toast.success("PDC Updated Successfully")
                    setSelectedTrans()
                    setUnitList([])
                    setTransList([])
                    window.location.reload();
                    handleClearFilters()
                } else {
                    setloader(false);
                }
            } else {
                setloader(false);
                return;
            }
        } catch (error) {
            setloader(false);
            console.error("Error Save Data", error);
        }
    }
    return (
        <div className='p-5'>
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>Transaction Details</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
                            <div className='d-flex gap-3'>
                                <div className='w-50'>
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start"> From Date</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={periodFrom}
                                        onChange={(date) => handlePeriodFromChange({ name: 'leaseDate', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100"
                                    />
                                </div>
                                <div className='w-50'>
                                    <label htmlFor="validationCustom01" className="form-label pt-1 start"> To Date</label>
                                    <DatePicker
                                        todayButton="Today"
                                        selected={periodTo}
                                        onChange={(date) => handlePeriodToChange({ name: 'toDate', value: date })}
                                        dateFormat="dd-MMM-yyyy"
                                        className="p-2 form-control w-100"
                                    />
                                </div>
                            </div>
                            <div className="">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> Account Type</label>
                                <WindowedSelect
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    value={transData.accountType}
                                    options={accountType?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handleAccountType(selectedOption)}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">AP / AR</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={transData.APAR}
                                    options={apar?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                    onChange={(selectedOption) => handleApAr(selectedOption)}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> Tran Type</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={transData.tranType}
                                    options={transList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handleTransType(selectedOption)}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Property</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={transData.property}
                                    options={proprtyList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                />
                            </div>
                            <div className="">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> Unit No</label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    className="w-100 p-0"
                                    value={transData.uniNo}
                                    options={unitList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                />
                            </div>
                            <div className='d-flex gap-5 center'>
                                <div className='gap-3 d-flex'>
                                    <input
                                        type="radio"
                                        name="dateOption"
                                        value="Cheque"
                                        checked={selectedOption === 'Cheque'}
                                        onChange={handleRadioChange}
                                    />
                                    <label className='center'>Cheque</label>
                                </div>
                                <div className='gap-3 d-flex'>
                                    <input
                                        type="radio"
                                        name="dateOption"
                                        value="Voucher"
                                        checked={selectedOption === 'Voucher'}
                                        onChange={handleRadioChange}
                                    />
                                    <label className='center'>Voucher</label>
                                </div>
                            </div>
                            <div className="d-flex gap-4 center">
                                <input
                                    style={{ width: "26px", height: "26px" }}
                                    type="checkbox"
                                    className="form-check-input center"
                                    checked={isCleared}
                                    onChange={handleCleared}
                                />
                                <label htmlFor="validationCustom01" className="form-label pt-2 start"> Cleared</label>
                            </div>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div className='d-flex gap-1 end'>
                                <div className="mainbtnGry flex-end gap-2" onClick={handleTransSearch}>
                                    <IoSearchOutline color="#fff" className="center mt-1 mx-2" />
                                    <div className="center">Search</div>
                                </div>
                                <div className="mainbtnRed flex-end gap-2" onClick={handleClearFilters} >
                                    <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                                {loading === true ? (
                                    <div className="mainbtn flex-end gap-2">
                                        <ClipLoader color="#ffffff" className="mt-1" size={25} />
                                    </div>
                                ) : (
                                    <div className="mainbtn flex-end gap-2" onClick={handleSave}>
                                        <FaSave color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Save</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='gridshad mt-2 mb-3'>
                <div className="table-container" style={{ overflowX: "auto", height: "600px" }}>
                    <table>
                        <thead className="dynoTable">
                            <tr>
                                <th>Cleared</th>
                                <th>Status</th>
                                <th>Follow Up</th>
                                <th>Remarks</th>
                                <th>Clearing Date</th>
                                <th>Voucher No</th>
                                <th>Voucher Date</th>
                                <th>Transection Type</th>
                                <th>Cheque No</th>
                                <th>Cheque Date</th>
                                <th>Amount</th>
                                <th>Cleared By</th>
                                <th>Drawn Bank</th>
                            </tr>
                        </thead>

                        {/* Rent Section */}
                        <tbody>
                            {Array.isArray(dataList) &&
                                dataList?.map((data, index) => (
                                    <tr key={index}>
                                        <td>
                                            <div className='center'>
                                                <input
                                                    style={{ width: "26px", height: "26px" }}
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    checked={data.IsChequeCleared || false}
                                                    onChange={(e) =>
                                                        handleCheckboxChange(index, e.target.checked)
                                                    }
                                                />
                                            </div>
                                        </td>
                                        <td><input className="p-1" value={data?.Status} disabled style={{ width: "100%" }} /></td>
                                        <td><input className="p-1" value={moment(data?.ChequeDate).format("DD-MMM-YYYY")} disabled style={{ width: "150px" }} /></td>
                                        <td><input className="p-1" value={data?.Remarks} disabled style={{ width: "100%" }} /></td>
                                        <td><input className="p-1" value={moment(data?.clearingDate || data?.ChequeDate).format("DD-MMM-YYYY")} disabled style={{ width: "150px" }} /></td>
                                        <td><input className="p-1" value={data?.VoucherNo} disabled style={{ width: "200px" }} /></td>
                                        <td><input className="p-1" value={moment(data?.ChequeDate).format("DD-MMM-YYYY")} disabled style={{ width: "150px" }} /></td>
                                        <td><input className="p-1" value={data?.TransactionMethod} disabled style={{ width: "150px" }} /></td>
                                        <td><input className="p-1" value={data?.ChequeNo} disabled style={{ width: "150px" }} /></td>
                                        <td><input className="p-1" value={moment(data?.ChequeDate).format("DD-MMM-YYYY")} disabled style={{ width: "150px" }} /></td>
                                        <td><input className="p-1" value={data?.Amount} disabled style={{ width: "100%" }} /></td>
                                        <td><input className="p-1" value={data?.ClearedBy === "0" ? "" : data?.ClearedBy} disabled style={{ width: "150px" }} /></td>
                                        <td><input className="p-1" value={data?.DrawnBank} disabled style={{ width: "250px" }} /></td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Update Cleared Info</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group>
                                <Form.Label>Clearing Date</Form.Label>
                                <DatePicker
                                    todayButton="Today"
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                    selected={formData.clearingDate}
                                    onChange={(date) => setFormData({ ...formData, clearingDate: date })}
                                />
                            </Form.Group>
                            <Form.Group className="mt-2">
                                <Form.Label>Status</Form.Label>
                                <Form.Select
                                    value={formData.status}
                                    onChange={(e) =>
                                        setFormData({ ...formData, status: e.target.value })
                                    }
                                >
                                    <option value="">Select</option>
                                    <option value="Deposited">Deposited</option>
                                    <option value="Bounced">Bounced</option>
                                    <option value="Hold">Hold</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className="mt-2">
                                <Form.Label>Remarks</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={formData.remarks}
                                    onChange={(e) =>
                                        setFormData({ ...formData, remarks: e.target.value })
                                    }
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleUpdate}>
                            Update
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default PaymentManagement;